import React from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { ModalDRC } from "./ModalDRC";
import { HeaderDRC } from "./HeaderDRC";
import { TablaDRC } from "./TablaDRC";
import { PromediosDRC } from "./PromediosDRC";

export const DatosDRC = ({ datosDRCHook, rangoDRC, isModoAnalisis }) => {
    const {
        AgregarDatoDRC,
        datosDRC,
        EliminarDatoDRC,
        SeleccionarDatoDRCParaEditar,
        ActualizarDatoDRC,

        mostrarModal,
        setMostrarModal,
        closeModal,

        datoDRCEditar,

        loadLaboratoristas,
    } = datosDRCHook;

    return (
        <div className="mt-4">
            <CardEmpty noShadow>
                <h6>DATOS DRC DE LABORATORIO</h6>
                {isModoAnalisis && <HeaderDRC setMostrarModal={setMostrarModal} />}
                <PromediosDRC datosDRC={datosDRC} />
                <ModalDRC
                    opened={mostrarModal}
                    onClose={closeModal}
                    loadLaboratoristas={loadLaboratoristas}
                    AgregarDatoDRC={AgregarDatoDRC}
                    datoDRCEditar={datoDRCEditar}
                    ActualizarDatoDRC={ActualizarDatoDRC}
                    rangoDRC={rangoDRC}
                />
                <TablaDRC
                    datosDRC={datosDRC}
                    SeleccionarDatoDRCParaEditar={SeleccionarDatoDRCParaEditar}
                    EliminarDatoDRC={EliminarDatoDRC}
                    isModoAnalisis={isModoAnalisis}
                />
            </CardEmpty>
        </div>
    );
};
